import React, { useState, useEffect } from 'react';
import { Edit, Trash2, Plus, Search, X, Download, MapPin, FileText, Edit2, Send, Eye, Loader2, Globe, Filter, Briefcase, ChevronDown, ChevronUp } from 'lucide-react';
import { useLanguage } from '../../StoreContext/LanguageContext';
import DownloadModal from '../../Components/Download/DownloadModal';
import apiService from '../../config';
import { useRef } from "react";
import RailwayAddLandHoldingList from "../landholding/RailwayAddLandHoldingList";
import RailwayEditLandHoldingList from "../landholding/RailwayEditLandHoldingList";
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';

const RailwayLandHoldingList = ({ onBack, setSelectedComponent, onNavigateWithModal, setSubComponent, shouldRestoreModal, modalParams, setShouldRestoreModal }) => {
    const { language, translations } = useLanguage();
    const formRef = useRef(null);
    const listRef = useRef(null);
    const [landholdingData, setLandholdingData] = useState([]);
    const [selectedLandId, setSelectedLandId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedLandholding, setSelectedLandholding] = useState(null);
    const [downloadModalOpen, setDownloadModalOpen] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProjectName, setCurrentProjectName] = useState(null);
    const [noticeModalOpen, setNoticeModalOpen] = useState(false);
    const [proposalId, setProposalId] = useState(null);
    const [notice6ModalOpen, setNotice6ModalOpen] = useState(false);

    // NEW: State to control the visibility of the Add Landholding form
    const [showAddForm, setShowAddForm] = useState(false);

    // NEW: State to control the visibility of the Edit Landholding form
    const [showEditForm, setShowEditForm] = useState(false);
    const [editingLandholding, setEditingLandholding] = useState(null);

    // Filter mode state - 'all' or 'location'
    const [filterMode, setFilterMode] = useState('location');

    // NEW: Controls whether dropdowns/search are visible when Filters button is clicked
    const [showDropdownSection, setShowDropdownSection] = useState(false);

    // Filter panel visibility state
    const [showFilterPanel, setShowFilterPanel] = useState(false);

    // ADD THESE NEW STATE VARIABLES HERE:
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        title: '',
        message: '',
        type: 'success'
    });
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({
        title: '',
        message: '',
        onConfirm: null,
        onCancel: null,
        type: 'warning'
    });
    const ROLES = {
        PROJECT_INCHARGE: 18,
        SAMANVAY: 6,
        COLLECTOR: 1,
        LAO: 3,
        DATA_ENTRY: 14
    };
    // ADD THESE HELPER FUNCTIONS HERE:
    const showAlert = (title, message, type = 'info') => {
        setAlertConfig({ title, message, type });
        setShowAlertModal(true);

        // Auto-hide after 5 seconds
        setTimeout(() => setShowAlertModal(false), 5000);
    };

    const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
        setConfirmConfig({ title, message, onConfirm, onCancel, type });
        setShowConfirmModal(true);
    };

    // Location selection states
    const [districts, setDistricts] = useState([]);
    const [talukas, setTalukas] = useState([]);
    const [villages, setVillages] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [selectedTaluka, setSelectedTaluka] = useState('');
    const [selectedVillage, setSelectedVillage] = useState('');
    const [selectedVillageName, setSelectedVillageName] = useState('');
    const [locationLoading, setLocationLoading] = useState({
        districts: false,
        talukas: false,
        villages: false
    });
    const [sentToSamanvay, setSentToSamanvay] = useState(false);

    // ADD: Pagination state variables
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    useEffect(() => {
        console.log('🗂 All localStorage contents:');
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            const value = localStorage.getItem(key);
            console.log(`${key}:`, value);
        }
    }, []);

    //Send to LAO-Samanvay-Collector
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showEditLandholdingModal, setShowEditLandholdingModal] = useState(false);
    const [showSendToCollectorModal, setShowSendToCollectorModal] = useState(false);
    const [editingLandholdingId, setEditingLandholdingId] = useState(null);
    const [users, setUsers] = useState([]);
    const [laoUsers, setLaoUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedLao, setSelectedLao] = useState('');
    const [assignLAO, setAssignLAO] = useState('');
    const [sendToRole, setSendToRole] = useState('LAO');
    const [changeLao, setChangeLao] = useState(false);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [remarks, setRemarks] = useState('Approved');
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [documentUrl, setDocumentUrl] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [sendingToSamanvay, setSendingToSamanvay] = useState(false);
    const [sendingToCollecotr, setSendingToCollecotr] = useState(false);
    const [sendingToLAO, setSendingToLAO] = useState(false);
    const [showProgress, setShowProgress] = useState(false);
    // const [currentProposalId, setCurrentProposalId] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [successMessage, setSuccessMessage] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [sendingToCollector, setSendingToCollector] = useState(false);
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [loadingTalukas, setLoadingTalukas] = useState(false);
    const [loadingVillages, setLoadingVillages] = useState(false);
    const [loadingRecords, setLoadingRecords] = useState(false);
    const [landRecords, setLandRecords] = useState([]);
    const [filteredRecords, setFilteredRecords] = useState([]);
    // Digital signature
    const { uploadStatus, uploadError, selectedSignDocument, resetSignatureState, signDocument } = useSignature();
    const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [pdfForSigning, setPdfForSigning] = useState(null);

    // ------------------------------------------------------------------------
    const [userRole, setUserRole] = useState(() => {
        try {
            const userData = localStorage.getItem("userData");
            console.log("---------------------1 :", userData);
            if (userData) {
                const user = JSON.parse(userData);
                return user.user_role || user.usr_role || null;
            }
        } catch (error) {
            console.error("Error parsing user data:", error);
        }
        return null;
    });


    useEffect(() => {
        const getProjectInfo = () => {
            const currentProjectData = localStorage.getItem('currentProjectData');
            const selectedProject = localStorage.getItem('selectedProject');
            console.log("---------------------3 :", selectedProject);
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return {
                        id: project.project_id || project.id,
                        name: project.project_name || project.name
                    };
                } catch (e) {
                    console.error('Error parsing selected project (selectedProject):', e);
                }
            }

            const userData = localStorage.getItem('userData');
            console.log("---------------------4 :", userData);
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    const projectId = user.data?.project_id || user.project_id;
                    const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
                    return {
                        id: projectId,
                        name: projectName
                    };
                } catch (e) {
                    console.error('Error parsing user data (userData):', e);
                }
            }
            return { id: null, name: null };
        };

        const projectInfo = getProjectInfo();
        setCurrentProjectId(projectInfo.id);
        console.log('Current Project Info:', projectInfo);
    }, []);

    useEffect(() => {
        const savedProposalId = localStorage.getItem('currentProposalId');
        console.log("---------------------6 :", savedProposalId);
        if (savedProposalId) {
            setProposalId(savedProposalId);
        }
        console.log('Current ProposalId Info:', savedProposalId);
    }, []);

    // Load land records for all locations
    const loadLandRecordsForAll = async () => {
        if (!currentProjectId || !proposalId) return;

        setLoadingRecords(true);
        try {
            const locationParams = { proposalId: proposalId };
            const result = await apiService.getRailwayLandHolding(currentProjectId, locationParams);

            if (result.status === 200 && Array.isArray(result.data)) {
                const transformedRecords = result.data.map((item, index) => ({
                    id: item.LandAcquisition_id || index + 1,
                    seqNo: index + 1,
                    gatNo: item.survey_no || 'N/A',
                    area: item.aqr_area || item.total_area || 0,
                    ...item
                }));
                setLandRecords(transformedRecords);
                setFilteredRecords(transformedRecords);
            } else {
                setLandRecords([]);
                setFilteredRecords([]);
            }
        } catch (error) {
            console.error('Error fetching all land holdings:', error);
            setLandRecords([]);
            setFilteredRecords([]);
        } finally {
            setLoadingRecords(false);
        }
    };

    // Load land records for specific location
    const loadLandRecordsForLocation = async () => {
        if (!currentProjectId || !proposalId) return;

        setLoadingRecords(true);
        try {
            const locationParams = { proposalId: proposalId };
            if (selectedDistrict) locationParams.distNo = selectedDistrict;
            if (selectedTaluka) locationParams.talukaNo = selectedTaluka;
            if (selectedVillage) locationParams.villageNo = selectedVillage;

            const result = await apiService.getRailwayLandHolding(currentProjectId, locationParams);

            if (result.status === 200 && Array.isArray(result.data)) {
                const transformedRecords = result.data.map((item, index) => ({
                    id: item.LandAcquisition_id || index + 1,
                    seqNo: index + 1,
                    gatNo: item.survey_no || 'N/A',
                    area: item.aqr_area || item.total_area || 0,
                    ...item
                }));
                setLandRecords(transformedRecords);
                setFilteredRecords(transformedRecords);
            } else {
                setLandRecords([]);
                setFilteredRecords([]);
            }
        } catch (error) {
            console.error('Error fetching land holdings:', error);
            setLandRecords([]);
            setFilteredRecords([]);
        } finally {
            setLoadingRecords(false);
        }
    };

    useEffect(() => {
        const sentFlag = localStorage.getItem('sentToSamanvay');

        console.log("---------------------2 :", sentFlag);
        setSentToSamanvay(sentFlag === 'true');
    }, []);

    useEffect(() => {
        try {
            // 1️⃣ Priority: selectedProposal
            const proposalStr = localStorage.getItem('selectedProposal');
            if (proposalStr) {
                const proposal = JSON.parse(proposalStr);
                if (proposal.dist_name) setSelectedDistrict(proposal.dist_name);
                if (proposal.taluka_name) setSelectedTaluka(proposal.taluka_name);
                if (proposal.village_name) setSelectedVillage(proposal.village_name);

                // Store in selectedLocationInfo so other logic still works
                localStorage.setItem('selectedLocationInfo', JSON.stringify({
                    projectId: currentProjectId,
                    district: proposal.dist_name || '',
                    taluka: proposal.taluka_name || '',
                    village: proposal.village_name || ''
                }));

                // ✅ Enable location filtering immediately
                setFilterMode('location');
                setShowDropdownSection(true);
                setShowFilterPanel(true);
                return; // stop here, no need to load fallback
            }

            // 2️⃣ Fallback: selectedLocationInfo
            const savedLocationInfo = localStorage.getItem('selectedLocationInfo');
            if (savedLocationInfo) {
                const locationInfo = JSON.parse(savedLocationInfo);
                if (locationInfo.district) setSelectedDistrict(locationInfo.district);
                if (locationInfo.taluka) setSelectedTaluka(locationInfo.taluka);
                if (locationInfo.village) setSelectedVillage(locationInfo.village);

                if (locationInfo.district || locationInfo.taluka || locationInfo.village) {
                    setFilterMode('location');
                    setShowDropdownSection(true);
                    setShowFilterPanel(true);
                }
            }
        } catch (error) {
            console.error('Error loading default location data:', error);
        }
    }, [currentProjectId]);

    useEffect(() => {
        if (currentProjectId && proposalId) {
            if (filterMode === 'all') {
                fetchLandholdingData();
            } else if (filterMode === 'location' && selectedDistrict) {
                // Fetch based on whatever location info is available
                fetchLandholdingData();
            }
        }
    }, [currentProjectId, proposalId, filterMode, selectedDistrict, selectedTaluka, selectedVillage]);

    // Fetch districts on component mount
    useEffect(() => {
        fetchDistricts();
    }, []);

    useEffect(() => {
        if (selectedDistrict || selectedTaluka || selectedVillage) {
            const locationInfo = {
                projectId: currentProjectId,
                district: selectedDistrict,
                taluka: selectedTaluka,
                village: selectedVillage
            };
            localStorage.setItem('selectedLocationInfo', JSON.stringify(locationInfo));
            console.log("---------------------8 :", locationInfo);
        }
    }, [selectedDistrict, selectedTaluka, selectedVillage, currentProjectId]);

    // Fetch talukas when district changes
    useEffect(() => {
        if (selectedDistrict) {
            setSelectedTaluka('');
            setSelectedVillage('');
            setVillages([]);
            fetchTalukas(selectedDistrict);
            // Only reset if coming from a different district
            if (talukas.length > 0) {
                const savedLocationInfo = localStorage.getItem('selectedLocationInfo');
                console.log("---------------------9 :", savedLocationInfo);
                let shouldReset = false;

                if (savedLocationInfo) {
                    try {
                        const locationInfo = JSON.parse(savedLocationInfo);
                        if (locationInfo.district === selectedDistrict) {
                            shouldReset = false;
                        }
                    } catch (error) {
                        console.error('Error parsing saved location info:', error);
                    }
                }

                if (shouldReset) {
                    setSelectedTaluka('');
                    setSelectedVillage('');
                    setVillages([]);
                }
            }
        }
    }, [selectedDistrict]);

    // Fetch villages when district and taluka change
    useEffect(() => {
        if (selectedDistrict && selectedTaluka) {
            setSelectedVillage('');
            setVillages([]);
            fetchVillages(selectedDistrict, selectedTaluka);
        }
    }, [selectedDistrict, selectedTaluka]);

    // from selectedProposal localstorage
    const fetchDistricts = async () => {
        try {
            setLocationLoading(prev => ({ ...prev, districts: true }));
            const result = await apiService.getDistricts();

            if (result.status === 200 && result.data) {
                setDistricts(result.data);

                // ✅ Auto-select from selectedProposal
                const proposalStr = localStorage.getItem('selectedProposal');
                if (proposalStr) {
                    try {
                        const proposal = JSON.parse(proposalStr);
                        if (proposal.dist_name) {
                            setSelectedDistrict(proposal.dist_name);
                        }
                    } catch (err) {
                        console.error('Error parsing selectedProposal in fetchDistricts:', err);
                    }
                }
            } else {
                throw new Error('Failed to fetch districts');
            }
        } catch (err) {
            console.error('Error fetching districts:', err);
            setError('Failed to load districts');
        } finally {
            setLocationLoading(prev => ({ ...prev, districts: false }));
        }
    };

    const fetchTalukas = async (distNo) => {
        try {
            setLocationLoading(prev => ({ ...prev, talukas: true }));
            const result = await apiService.getTalukas(distNo);

            if (result.status === 200 && result.data) {
                setTalukas(result.data);

                // ✅ Auto-select from selectedProposal
                const proposalStr = localStorage.getItem('selectedProposal');
                if (proposalStr) {
                    try {
                        const proposal = JSON.parse(proposalStr);
                        if (proposal.taluka_name) {
                            setSelectedTaluka(proposal.taluka_name);
                        }
                    } catch (err) {
                        console.error('Error parsing selectedProposal in fetchTalukas:', err);
                    }
                }
            } else {
                throw new Error('Failed to fetch talukas');
            }
        } catch (err) {
            console.error('Error fetching talukas:', err);
            setError('Failed to load talukas');
        } finally {
            setLocationLoading(prev => ({ ...prev, talukas: false }));
        }
    };

    const fetchVillages = async (dist, taluka) => {
        try {
            const res = await apiService.getVillages(dist, taluka);
            if (res.status === 200) {
                setVillages(res.data);

                // ✅ Auto-select from selectedProposal
                const proposalStr = localStorage.getItem('selectedProposal');
                if (proposalStr) {
                    try {
                        const proposal = JSON.parse(proposalStr);
                        if (proposal.village_name) {
                            setSelectedVillage(proposal.village_name);
                        }
                    } catch (err) {
                        console.error('Error parsing selectedProposal in fetchVillages:', err);
                    }
                }
            } else {
                setVillages([]); // fallback
            }
        } catch (err) {
            console.error('Error fetching villages:', err);
            setVillages([]);
        }
    };

    useEffect(() => {
        if (showSendToCollectorModal && sendToRole === 'Collector') {
            // fetchUsersLAO();
            fetchAssignLAO();
        }
    }, [showSendToCollectorModal, sendToRole]);

    const fetchLandholdingData = async () => {
        try {
            setLoading(true);
            setError(null);

            if (!currentProjectId || !proposalId) {
                throw new Error('Project ID or Proposal ID missing.');
            }

            let result;

            if (filterMode === 'all') {
                // Fetch all records for the project
                result = await apiService.getRailwayLandHolding(currentProjectId, { proposalId });
            } else {
                // Construct location filter params progressively
                const locationParams = {
                    proposalId,
                };

                if (selectedDistrict) {
                    locationParams.distNo = selectedDistrict;
                }

                if (selectedTaluka) {
                    locationParams.talukaNo = selectedTaluka;
                }

                if (selectedVillage) {
                    locationParams.villageNo = selectedVillage;
                }

                // Fetch filtered records based on available params
                result = await apiService.getRailwayLandHolding(currentProjectId, locationParams);
            }

            if (result.status === 200 && result.data) {
                const transformedData = result.data.map((item, index) => ({
                    groupNo: item.LandAcquisition_id,
                    landholdersName: item.landholder_name || '',
                    DistrictName: item.dist_name,
                    TalukaName: item.taluka_name,
                    VillageName: item.village_name || 'Unknown Village',
                    SurveyNO: item.survey_no || '',
                    irrigableArea: parseFloat(item.irrigable_area) || 0,
                    nonIrrigableArea: parseFloat(item.non_irrigable_area) || 0,
                    totalArea: parseFloat(item.total_area) || 0,
                    AquiredArea: parseFloat(item.aqr_area) || 0,
                    unit_name: item.unit_name || '',
                    status: item.is_active,
                    project_id: item.project_id,
                    village_id: item.village_id,
                    survey_type: item.survey_type,
                    irrigable_type: item.irrigable_type,
                    owners: item.owners || [],
                    cre_usr_id: item.cre_usr_id,
                    cre_usr_dt: item.cre_usr_dt,
                    last_upd_id: item.last_upd_id,
                    last_upd_dt: item.last_upd_dt
                }));

                setLandholdingData(transformedData);
                console.log('✅ landholdingData set to:', transformedData);

            } else {
                throw new Error('Invalid API response format');
            }
        } catch (err) {
            console.error('Error fetching landholding data:', err);
            setError(err.message);
            setLandholdingData([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchUsersCollector = async () => {
        setLoadingUsers(true);
        try {
            const response = await apiService.getAllUserCollector();
            if (response.status === 200 && response.data) {
                const data = Array.isArray(response.data) ? response.data : [];
                setUsers(data);
                if (data.length > 0) {
                    setSelectedUser(data[0].id || data[0].usr_id);
                }
            }
        } catch (error) {
            console.error('Error fetching Collector users:', error);
            setUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    };

    const fetchUsersLAO = async () => {
        setLoadingUsers(true);
        try {
            const response = await apiService.getAllUserRoleLAO();
            if (response.status === 200 && response.data) {
                const users = Array.isArray(response.data) ? response.data : [];
                setLaoUsers(users);
            }
        } catch (error) {
            console.error('Error fetching LAO users:', error);
            setLaoUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    };


    const fetchAssignLAO = async () => {
        setLoadingUsers(true);
        const role = 3;
        const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
        const projectId = selectedProject?.id || selectedProject?.project_id;

        try {
            const response = await apiService.getAssignLAO(role, projectId, proposalId);
            if (response.status === 200 && response.data) {
                setAssignLAO(Array.isArray(response.data) ? response.data : []);
            }
        } catch (error) {
            console.error('Error fetching assigned LAO:', error);
            setAssignLAO([]);
        } finally {
            setLoadingUsers(false);
        }
    };

    // Assign LAO
    const handleAssignLAO = async (laoUserId) => {
        const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
        const projectId = selectedProject?.id || selectedProject?.project_id;

        if (!laoUserId || !projectId || !proposalId) {
            showAlert('Missing Information', 'All fields are required to assign LAO Officer.');
            return;
        }

        const payload = {
            usr_id: laoUserId,
            usr_role: 3,
            project_id: projectId,
            acquisition_proposal_id: proposalId,   // ✅ state variable
            is_active: 1
        };

        const response = await apiService.addAssignRole(payload);
        console.log("✅ LAO Assigned Successfully:", response);
    };

    // Send to Collector
    const handleSendToCollector = async (collectorUserId) => {
        const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
        const projectId = selectedProject?.id || selectedProject?.project_id;

        setSendingToCollector(true);
        setShowProgress(true);
        setUploadProgress(0);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);   // ✅ state variable
            formData.append('remarks', remarks);
            formData.append('usr_id', collectorUserId);
            formData.append('document', selectedDocument);

            const response = await apiService.postRailwayTrackingCollector(formData);
            if (response.status === 200) {
                setUploadProgress(100);
                await new Promise(resolve => setTimeout(resolve, 500));

                setSuccessMessage('Successfully sent to Collector!');
                setShowSuccess(true);
                setTimeout(() => setShowSuccess(false), 5000);

                fetchButtonStatus();
                setTimeout(() => setShowSuccess(false), 5000);
            } else {
                setUploadProgress(0);
            }
        } catch (error) {
            setUploadProgress(0);
            showAlert('Failed to send to Collector. Please check your connection and try again.');
        } finally {
            setSendingToCollector(false);
            setShowProgress(false);
            setUploadProgress(0);
        }
    };

    // Send to LAO
    const handleSendToLAO = async () => {
        const finalSelectedUser = selectedLao ||
            (assignLAO && Array.isArray(assignLAO) && assignLAO.length > 0
                ? assignLAO[0].usr_id || assignLAO[0].id
                : null);

        if (!finalSelectedUser || !selectedDocument) {
            alert('Please select a LAO and upload a document');
            return;
        }

        const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
        const projectId = selectedProject?.id || selectedProject?.project_id;

        setSendingToLAO(true);
        setShowProgress(true);
        setUploadProgress(0);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);   // ✅ state variable
            formData.append('remarks', remarks);
            formData.append('usr_id', finalSelectedUser);
            formData.append('document', selectedDocument);

            const response = await apiService.postRailwayTrackingLAO(formData);
            if (response.status === 200) {
                setUploadProgress(100);
                await new Promise(resolve => setTimeout(resolve, 500));

                setSuccessMessage('Successfully Send to LAO Officer!');
                setShowSuccess(true);
                setTimeout(() => setShowSuccess(false), 3000);

                setShowSendToCollectorModal(false);
                setSelectedUser('');
                setSelectedLao('');
                setChangeLao(false);
                setRemarks('Approved');
                setSelectedDocument(null);
                fetchButtonStatus();
            } else {
                setUploadProgress(0);
            }
        } catch (error) {
            setUploadProgress(0);
            console.error('Error appointing LAO:', error);
            showAlert('Failed to appoint LAO Officer.');
        } finally {
            setSendingToLAO(false);
            setShowProgress(false);
            setUploadProgress(0);
        }
    };

    // Send to Samanvay
    const handleSendToSamanvay = async () => {
        if (!selectedUser || !selectedDocument) {
            alert('Please select a user and upload a document');
            return;
        }

        const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
        const projectId = selectedProject?.id || selectedProject?.project_id;

        setSendingToSamanvay(true);
        setShowProgress(true);
        setUploadProgress(0);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);   // ✅ state variable
            formData.append('remarks', remarks);
            formData.append('usr_id', selectedUser);
            formData.append('document', selectedDocument);

            const response = await apiService.postRailwayTrackingSamanvay(formData);
            if (response.status === 200) {
                setUploadProgress(100);
                await new Promise(resolve => setTimeout(resolve, 500));

                setSuccessMessage('Successfully sent to Samanvay Officer!');
                setShowSuccess(true);
                setTimeout(() => setShowSuccess(false), 5000);

                setShowSendToCollectorModal(false);
                setSelectedUser('');
                setRemarks('Approved');
                setSelectedDocument(null);
                fetchButtonStatus();
            } else {
                setUploadProgress(0);
            }
        } catch (error) {
            setUploadProgress(0);
            console.error('Error sending to Samanvay:', error);
            showAlert('Failed to send to Samanvay Officer. Please check your connection and try again.');
        } finally {
            setSendingToSamanvay(false);
            setShowProgress(false);
            setUploadProgress(0);
        }
    };

    // Generic handler
    const handleSendToSurveyor = async () => {
        const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
        const projectId = selectedProject?.id || selectedProject?.project_id;

        if (sendToRole === 'Samanvay') {
            if (!selectedUser || !selectedDocument) {
                showAlert('Please select a user and upload a document');
                return;
            }
            await handleSendToSamanvay();
        }
        else if (sendToRole === 'LAO') {
            if (!selectedLao || !selectedDocument) {
                showAlert('Please select a user and upload a document');
                return;
            }
            await handleSendToLAO();
        }
        else if (sendToRole === 'Collector') {
            if (!selectedUser || !selectedLao || !selectedDocument) {
                showAlert('Please select Collector, LAO, and upload a document');
                return;
            }

            try {
                setSendingToCollector(true);
                await handleAssignLAO(selectedLao);
                await handleSendToCollector(selectedUser);
                setShowSendToCollectorModal(false);
                setSelectedUser('');
                setSelectedLao('');
                setChangeLao(false);
                setRemarks('Approved');
                setSelectedDocument(null);
                fetchButtonStatus();
            } catch (err) {
                console.error("Error in Collector flow:", err);
                showAlert("Something went wrong while processing.");
            } finally {
                setSendingToCollector(false);
            }
        }
    };

    const handleSendToLAOClick = async () => {
        resetModalState();
        setSendToRole('LAO');
        if (buttonDisabled) {
            showConfirm(
                'Confirm Re-submission',
                'You have already sent this proposal once. Are you sure you want to send it again?',
                () => {
                    setShowSendToCollectorModal(true);
                    fetchAssignLAO();
                    // fetchUsersLAO();
                }
            );
            return;
        }
        setShowSendToCollectorModal(true);
        await fetchAssignLAO();
        // await fetchUsersLAO();

        // ✅ mark as disabled after first success
        setButtonDisabled(true);
    };


    const fetchButtonStatus = async () => {
        try {
            if (!currentProjectId || !proposalId) return;

            setLoading(true);
            let response;

            switch (userRole) {
                case ROLES.PROJECT_INCHARGE:
                    response = await apiService.getRailwaySamanvayButton(currentProjectId, proposalId);
                    break;
                case ROLES.SAMANVAY:
                    response = await apiService.getRailwayCollectorButton(currentProjectId, proposalId);
                    break;
                case ROLES.COLLECTOR:
                    response = await apiService.getRailwayLAOButton(currentProjectId, proposalId);
                    break;
                default:
                    return;
            }
            setButtonDisabled(!response.buttonDisable);
        } catch (error) {
            console.error("Error fetching button state:", error);
        } finally {
            setLoading(false);
        }
    };
    // Refresh records based on current filter mode
    const refreshRecords = async () => {
        if (filterMode === 'all') {
            await loadLandRecordsForAll();
        } else if (selectedDistrict && selectedTaluka && selectedVillage) {
            await loadLandRecordsForLocation();
        }
    };
    // Reset modal state
    const resetModalState = () => {
        setSelectedUser('');
        setRemarks('Approved');
        setSelectedDocument(null);
        setUsers([]);
    };

    // Handle sending to different roles
    const handleSendToSamanvayClick = () => {
        resetModalState();
        setSendToRole('Samanvay');
        if (buttonDisabled) {
            showConfirm(
                'Confirm Re-submission',
                'You have already sent this proposal once. Are you sure you want to send it again?',
                () => {
                    // localStorage.setItem('sentToSamanvay', 'true');
                    // localStorage.setItem('sentProposalId', proposalId);
                    setShowSendToCollectorModal(true);
                    fetchUsersSamanvay();
                }
            );
            return;
        }

        // localStorage.setItem('sentToSamanvay', 'true');
        // localStorage.setItem('sentProposalId', proposalId);
        setShowSendToCollectorModal(true);
        fetchUsersSamanvay();
    };

    // MODIFIED: handleAddNew now shows the form instead of navigating
    const handleAddNew = () => {
        if (!currentProjectId || !proposalId) {
            showAlert('Project ID or Proposal ID missing! Please check your project and proposal selection.');
            return;
        }
        const info = {
            projectId: currentProjectId,
            proposalId: proposalId,
            district: '',
            taluka: '',
            village: ''
        };

        if (filterMode === 'location') {
            info.district = selectedDistrict;
            info.taluka = selectedTaluka;
            info.village = selectedVillage;
        }
        console.log("🚀 handleAddNew - Sending to localStorage → selectedLocationInfo:", info);

        localStorage.setItem('selectedLocationInfo', JSON.stringify(info));
        console.log("---------------------12 :", info);

        // Show the add form and hide edit form if it's open
        setShowAddForm(true);
        setShowEditForm(false);
        setEditingLandholding(null);

        setTimeout(() => {
            formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 0);
    };

    // Handle document view
    const handleViewDocument = (file) => {
        const url = URL.createObjectURL(file);
        setDocumentUrl(url);
        setShowModal(true);
    };

    // Restore modal state from parameters
    useEffect(() => {
        if (shouldRestoreModal && modalParams) {
            // Restore modal open state
            setShowSendToCollectorModal(true);
            fetchUsersSamanvay();
            // Restore previous selections
            // Save for later restoration when users arrive
            pendingRestore.current = {
                user: modalParams.selectedUser || '',
                lao: modalParams.selectedLao || '',
                remarks: modalParams.remarks || '',
            };

            setRemarks(modalParams.remarks || '');
            setSendToRole(modalParams.sendToRole || 'Collector');

            // Reset flag so modal doesn't restore again automatically
            setShouldRestoreModal(false);
        }
    }, [shouldRestoreModal, modalParams]);

    useEffect(() => {
        if (pendingRestore.current) {
            if (users.length > 0 || laoUsers.length > 0) {
                setSelectedUser(pendingRestore.current.user);
                setSelectedLao(pendingRestore.current.lao);
                setRemarks(pendingRestore.current.remarks);

                pendingRestore.current = null; // clear after applying
            }
        }
    }, [users, laoUsers]);

    const pendingRestore = useRef(null);

    // Navigate to covering letters with modal state
    const handleCoveringLetterClick = () => {
        const modalState = {
            selectedUser,
            userId: selectedLao,
            remarks,
            sendToRole,
            selectedDocumentName: selectedDocument?.name || null,
            timestamp: new Date().getTime(),
        };

        if (typeof onNavigateWithModal !== "function") {
            console.error("❌ onNavigateWithModal missing in RailwayLandHoldingList");
            return;
        }

        onNavigateWithModal("CoveringLetters", modalState);
    };

    // NEW: Handle form submission success - refresh data and hide form
    const handleAddSuccess = () => {
        fetchLandholdingData();
        fetchLandholdingData();
        // Refresh the landholding data
        if (currentProjectId && proposalId) {
            fetchLandholdingData();
        }
    };


    // NEW: Handle form cancel - just hide the form
    const handleAddCancel = () => {
        setShowAddForm(false);
    };

    // NEW: Handle edit form submission success - refresh data and hide form
    const handleEditSuccess = () => {
        if (currentProjectId && proposalId) {
            fetchLandholdingData();
        }
    };

    // NEW: Handle edit form cancel - just hide the form
    const handleEditCancel = () => {
        setShowEditForm(false);
        setEditingLandholding(null);
        setSelectedLandId(null);
    };

    // MODIFIED: handleEdit now shows the form instead of navigating
    const handleEdit = (index) => {
        const landholdingToEdit = landholdingData[index];

        // Store data in localStorage as backup
        localStorage.setItem('editingLandholding', JSON.stringify(landholdingToEdit));
        console.log("---------------------13 :", landholdingToEdit);
        // localStorage.setItem('currentProjectId', currentProjectId);

        if (filterMode === 'location') {
            localStorage.setItem('selectedLocationInfo', JSON.stringify({
                district: selectedDistrict,
                taluka: selectedTaluka,
                village: selectedVillage
            }));

            console.log("---------------------14 :", localStorage.getItem('selectedLocationInfo'));
        } else {
            localStorage.setItem('selectedLocationInfo', JSON.stringify({
                district: '',
                taluka: '',
                village: ''
            }));

            console.log("---------------------15 :", localStorage.getItem('selectedLocationInfo'));
        }

        // Extract the correct land ID
        const landId = landholdingToEdit.groupNo;

        console.log('Editing landholding:', landholdingToEdit);
        console.log('Using land ID:', landId);
        console.log('Project ID:', currentProjectId);

        // Set the selected land ID state
        setSelectedLandId(landId);

        // Set the editing landholding data and show the edit form
        setEditingLandholding(landholdingToEdit);
        setShowEditForm(true);

        // Hide add form if it's open
        setShowAddForm(false);
        setTimeout(() => {
            formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 0);
    };

    const handleDelete = async (index) => {
        const landholding = landholdingData[index];

        showConfirm(
            'Delete Landholding',
            `Are you sure you want to delete landholding for ${landholding.landholdersName || 'this record'}?`,
            async () => {
                try {
                    // Make API call to delete if LandAcquisition_id exists
                    if (landholding.groupNo) {
                        const response = await apiService.deleteRailwayLandHolding(landholding.groupNo);

                        if (response.status !== 200) {
                            throw new Error('Failed to delete from server');
                        }
                    }

                    // Remove from local state
                    const updatedData = landholdingData.filter((_, i) => i !== index);
                    setLandholdingData(updatedData);
                    showAlert('Success', 'Landholding deleted successfully!', 'success');
                } catch (err) {
                    console.error('Error deleting landholding:', err);
                    showAlert('Error', 'Failed to delete landholding. Please try again.', 'error');
                }
            },
            null,
            'danger'
        );
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handlePrastavna = () => {
        setSubComponent('Prastavna');
    };
    const handleNamuna_Kh = () => {
        setSubComponent('Namuna_Kh');
    };
    const handleParishtisht_A = () => {
        setSubComponent('Parishtisht_A');
    };
    const handleAnnexure_E = () => {
        setSubComponent('Annexure_E');
    };
    const handleParishtisht_ASubmissionLetter = () => {
        setSubComponent('Parishtisht_ASubmissionLetter');
    };
    const handleParishtisht_B = () => {
        setSubComponent('Parishtisht_B');
    };
    const handleCreditorList = () => {
        setSubComponent('CreditorList');
    };
    const handleAcquisitionBoundaryAndArea = () => {
        setSubComponent('AcquisitionBoundaryAndArea');
    };
    const handlePrivateLandForm1 = () => {
        setSubComponent('PrivateLandForm1');
    };
    const handlePrivateLandForm2 = () => {
        setSubComponent('PrivateLandForm2');
    };
    const handleOther = () => {
        setSubComponent('Other');
    };
    const handle7_12 = () => {
        setSubComponent('Docu7_12');
    };
    const handleEight_A = () => {
        setSubComponent('Eight_A');
    };
    const handleVillageMap = () => {
        setSubComponent('VillageMap');
    };

    const getColumnsForDownload = () => {
        return [
            { header: 'S.No.', value: 'index' },
            { header: 'Land No', value: 'groupNo' },
            { header: 'Landholders Name', value: 'landholdersName' },
            { header: 'Village Name', value: 'VillageName' },
            { header: 'Survey No', value: 'SurveyNO' },
            { header: 'Irrigative Area', value: 'irrigableArea' },
            { header: 'Non-Irrigative Area', value: 'nonIrrigableArea' },
            { header: 'Total Area', value: 'totalArea' },
            { header: 'Acquired Area', value: 'AquiredArea' },
            { header: 'Area Unit', value: 'unit_name' },
            { header: 'Status', value: 'status' }
        ];
    };

    const getDataForDownload = () => {
        return filteredData.map((landholding, index) => ({
            ...landholding,
            index: index + 1,
            status: landholding.status ? 'Active' : 'Inactive'
        }));
    };

    const filteredData = landholdingData.filter(record => {
        // Convert all values to strings and handle potential null/undefined values
        const groupNo = String(record.groupNo || '').toLowerCase();
        const landholdersName = String(record.landholdersName || '').toLowerCase();
        const villageName = String(record.VillageName || '').toLowerCase();
        const surveyNo = String(record.SurveyNO || '').toLowerCase();

        const searchTermLower = searchTerm.toLowerCase();

        return groupNo.includes(searchTermLower) ||
            landholdersName.includes(searchTermLower) ||
            surveyNo.includes(searchTermLower) ||
            villageName.includes(searchTermLower);
    });

    // ADD: Pagination logic
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    // Reset to first page when search term changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, selectedDistrict, selectedTaluka, selectedVillage, filterMode]);


    const [buttonDisabled, setButtonDisabled] = useState(false);
    useEffect(() => {
        fetchButtonStatus();
    }, [currentProjectId, proposalId, userRole]);

    useEffect(() => {
    }, [landholdingData]);

    const fetchUsersSamanvay = async () => {
        setLoadingUsers(true);
        try {
            const response = await apiService.getAllUserRoleSamanvay();
            if (response.status === 200 && response.data) {
                setUsers(Array.isArray(response.data) ? response.data : []);
            }
        } catch (error) {
            console.error('Error fetching Samanvay users:', error);
            setUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    };

    // Progress Bar Component (add this as a new component)
    const ProgressBar = ({ progress, isVisible }) => {
        if (!isVisible) return null;

        return (
            <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
                <div
                    className="bg-blue-600 h-2 rounded-full transition-all duration-500 ease-out"
                    style={{ width: `${progress}%` }}
                />
                <div className="flex justify-between text-xs text-gray-500 mt-1">
                    <span>{translations[language].saving}</span>
                    <span>{progress}%</span>
                </div>
            </div>
        );
    };
    const [expandedRow, setExpandedRow] = useState(null);

    const toggleRow = (id) => {
        setExpandedRow(expandedRow === id ? null : id);
    };

    const isLocationSelectionComplete = selectedDistrict || selectedTaluka || selectedVillage;
    const canShowData = filterMode === 'all' || (filterMode === 'location' && isLocationSelectionComplete);

    const shouldShowButton = (buttonName) => {
        if (!userRole) return false;

        // Define which buttons each role can see
        const rolePermissions = {
            '15': ['all'], // DSLR
            '6': ['all'], // Samanvay - Show all buttons
            '18': ['all'], // Project Incharge - Show all buttons
            '3': ['all'], // LAO - Show all buttons
            //  Data Entry 
            '14': ['all'], // Data entry - Show all buttons
        };

        // Convert userRole to string
        const normalizedRole = String(userRole).trim();

        // console.log('User Role:', userRole, 'Normalized:', normalizedRole);

        // Check if role has permissions
        const permissions = rolePermissions[normalizedRole];

        if (!permissions) {
            console.log('No permissions found for role:', normalizedRole);
            return false;
        }

        // If role has 'all' permission, show everything
        if (permissions.includes('all')) return true;

        // Otherwise check if specific button is in permissions
        return permissions.includes(buttonName.toLowerCase());
    };

    return (
        <div className="p-4">
            {/* Action Buttons - No Container */}
            <div className="mb-6">
                <div className="flex flex-wrap gap-3">

                    <button
                        onClick={() => setFilterMode('all')}
                        className="px-5 py-3 text-sm bg-gradient-to-r from-yellow-600 to-yellow-700 hover:from-yellow-700 hover:to-yellow-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-orange-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <Globe className="h-4 w-4" />
                        <span>{translations[language].allRecords}</span>
                    </button>

                    <button
                        onClick={() => {
                            setFilterMode('location');
                            setShowFilterPanel(!showFilterPanel)
                            setShowDropdownSection(true);
                        }}
                        className="px-5 py-3 text-sm bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-orange-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <Filter className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                        <span className="font-medium">{translations[language].filters}</span>
                        {showFilterPanel ?
                            <ChevronUp className="h-4 w-4 transition-transform duration-300" /> :
                            <ChevronDown className="h-4 w-4 transition-transform duration-300" />
                        }
                    </button>

                    {/* Prastavna */}
                    {shouldShowButton('prastavna') && (
                        <button
                            onClick={() => handlePrastavna(true)}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].introduction}</span>
                        </button>
                    )}
                    {/* Namuna_Kh */}
                    {shouldShowButton('namuna_Kh') && (
                        <button
                            onClick={() => handleNamuna_Kh("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].namuna_Kh}</span>
                        </button>
                    )}

                    {/* Parishtisht_A (double cort) */}
                    {shouldShowButton('parishtisht_A') && (
                        <button
                            onClick={() => handleParishtisht_A(true)}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">परिशिष्ट “अ”</span>
                        </button>
                    )}

                    {/* Annexure_E */}
                    {shouldShowButton('annexure_E') && (
                        <button
                            onClick={() => handleAnnexure_E("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].annexure_E}</span>
                        </button>
                    )}

                    {/* parishtisht_ASubmissionLetter (single cort)*/}
                    {shouldShowButton('parishtisht_ASubmissionLetter') && (
                        <button
                            onClick={() => handleParishtisht_ASubmissionLetter("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">परिशिष्ट 'अ'</span>
                        </button>
                    )}

                    {/* parishtisht_B*/}
                    {shouldShowButton('parishtisht_B') && (
                        <button
                            onClick={() => handleParishtisht_B("true")}
                            // disabled={!canShowData || landholdingData.length === 0}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">परीशिष्ट 'ब'</span>
                        </button>
                    )}

                    {/* CreditorList */}
                    {shouldShowButton('creditorList') && (
                        <button
                            onClick={() => handleCreditorList("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].creditorList}</span>
                        </button>
                    )}

                    {/* AcquisitionBoundaryAndArea */}
                    {shouldShowButton('acquisitionBoundaryAndArea') && (
                        <button
                            onClick={() => handleAcquisitionBoundaryAndArea("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].acquisitionBoundaryAndArea}</span>
                        </button>
                    )}

                    {/* PrivateLandForm1 */}
                    {shouldShowButton('privateLandForm1') && (
                        <button
                            onClick={() => handlePrivateLandForm1("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].privateLandForm1}</span>
                        </button>
                    )}

                    {/* PrivateLandForm2*/}
                    {shouldShowButton('privateLandForm2') && (
                        <button
                            onClick={() => handlePrivateLandForm2("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].privateLandForm2}</span>
                        </button>
                    )}

                    {/* Other Forms */}
                    {shouldShowButton('other') && (
                        <button
                            onClick={() => handleOther("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].Other}</span>
                        </button>
                    )}

                    {/* 7/12 */}
                    {shouldShowButton('7/12') && (
                        <button
                            onClick={() => handle7_12("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].docu7_12}</span>
                        </button>
                    )}
                    {/* आठ-अ */}
                    {shouldShowButton('Eight_A') && (
                        <button
                            onClick={() => handleEight_A("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].eight_A}</span>
                        </button>
                    )}
                    {/* Village map */}
                    {shouldShowButton('VillageMap') && (
                        <button
                            onClick={() => handleVillageMap("true")}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].villageMap}</span>
                        </button>
                    )}

                    {/* {userRole === 18 && ( */}
                    {/* Data Entry */}
                    {(userRole === 18 || userRole === 14) && (
                        <button
                            onClick={handleAddNew}
                            disabled={buttonDisabled}
                            className={`px-5 py-3 text-sm rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg font-medium group ${buttonDisabled
                                ? // Disabled state
                                'bg-gray-500 text-white cursor-not-allowed shadow-gray-200 opacity-60'
                                : // Enabled state
                                'bg-gradient-to-r from-blue-600 to-gray-900 hover:from-blue-700 hover:to-blue-800 text-white shadow-blue-200 hover:shadow-blue-300 cursor-pointer'
                                }`}
                        >
                            <Plus className="h-5 w-5 group-hover:rotate-90 transition-transform duration-300" />
                            <span className="font-medium">{translations[language].AddLandholding}</span>
                        </button>
                    )}

                    {/* Role-based Action Buttons */}
                    <div className="flex gap-4">

                        {/* Project Incharge Button */}
                        {userRole === ROLES.PROJECT_INCHARGE && (
                            <>

                                <br /> {/* Just to separate the buttons */}

                                <button
                                    onClick={handleSendToSamanvayClick}
                                    disabled={loading || sendingToSamanvay}
                                    className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                                        ? 'bg-red-600 text-white hover:bg-red-700'
                                        : loading || sendingToSamanvay
                                            ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                            : 'bg-purple-600 text-white hover:bg-purple-700'
                                        }`}
                                >
                                    {sendingToSamanvay ? (
                                        <>
                                            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                            {translations[language]?.Sending}
                                        </>
                                    ) : loading ? (
                                        <span>{translations[language]?.Checking}</span>
                                    ) : (
                                        <span>{translations[language]?.SendToSamanvayOfficer}</span>
                                    )}
                                </button>
                            </>

                        )}

                        {/* Samanvay Button */}
                        {userRole === ROLES.SAMANVAY && (
                            <button
                                onClick={() => {
                                    if (buttonDisabled) {
                                        showConfirm(
                                            'Confirm Re-submission',
                                            'You have already sent once. Do you want to send again?',
                                            () => {
                                                setSendToRole('Collector');
                                                setShowSendToCollectorModal(true);
                                                fetchUsersCollector();
                                            }
                                        );
                                        return;
                                    }
                                    setSendToRole('Collector');
                                    setShowSendToCollectorModal(true);
                                    fetchUsersCollector();
                                }}
                                disabled={loading || sendingToCollector}
                                className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                                    ? 'bg-red-600 text-white hover:bg-red-700'
                                    : loading || sendingToCollector
                                        ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                        : 'bg-purple-600 text-white hover:bg-purple-700'
                                    }`}
                            >
                                {sendingToCollector ? (
                                    <>
                                        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                        {translations[language]?.Sending}
                                    </>
                                ) : loading ? (
                                    <span>{translations[language]?.Checking}</span>
                                ) : (
                                    <span>{translations[language]?.SendToCollector}</span>
                                )}
                            </button>
                        )}

                        {/* Collector Button */}
                        {userRole === ROLES.COLLECTOR && (
                            <button
                                onClick={handleSendToLAOClick}
                                disabled={loading || sendingToLAO}
                                className={`flex items-center px-4 py-2 rounded-lg transition-colors ${loading || sendingToLAO
                                    ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                    : buttonDisabled
                                        ? 'bg-red-600 text-white hover:bg-red-700'
                                        : 'bg-purple-600 text-white hover:bg-purple-700'
                                    }`}

                            >
                                {sendingToLAO ? (
                                    <>
                                        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                        {translations[language]?.Assigning}
                                    </>
                                ) : loading ? (
                                    <span>{translations[language]?.Checking}</span>
                                ) : (
                                    <span>{translations[language]?.AssignLAOOfficer}</span>
                                )}
                            </button>
                        )}

                    </div>
                </div>
            </div>

            {/* Collapsible Filter Panel */}
            {showFilterPanel && (
                <div className="mb-6 bg-gray-50/50 backdrop-blur-sm border border-gray-200 rounded-lg">
                    <div className="p-6 space-y-6">
                        {/* Location Selection - Only show when location filter is selected */}
                        {showDropdownSection && (
                            <div className="space-y-4">
                                <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
                                    {/* District Dropdown */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            {translations[language].district} <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            value={selectedDistrict}
                                            onChange={(e) => setSelectedDistrict(e.target.value)}
                                            disabled={locationLoading.districts}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                                        >
                                            <option value="">
                                                {locationLoading.districts ? <span>{translations[language].loadingDistricts}</span> : <span>{translations[language].selectDistrict}</span>}
                                            </option>
                                            {districts.map((district) => (
                                                <option key={district.dist_name} value={district.dist_name}>
                                                    {district.dist_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Taluka Dropdown */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            {translations[language].taluka} <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            value={selectedTaluka}
                                            onChange={(e) => setSelectedTaluka(e.target.value)}
                                            disabled={!selectedDistrict || locationLoading.talukas}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                                        >
                                            <option value="">
                                                {locationLoading.talukas ? <span>{translations[language].loadingTalukas}</span> : <span>{translations[language].selectTaluka}</span>}
                                            </option>
                                            {talukas.map((taluka) => (
                                                <option key={taluka.taluka_name} value={taluka.taluka_name}>
                                                    {taluka.taluka_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Village Dropdown */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            {translations[language].village} <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            value={selectedVillage}
                                            onChange={(e) => setSelectedVillage(e.target.value)}
                                            disabled={!selectedTaluka || locationLoading.villages}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                                        >
                                            <option value="">
                                                {locationLoading.villages ? <span>{translations[language].loadingVillages}</span> : <span>{translations[language].selectVillage}</span>}
                                            </option>
                                            {villages.map((village) => (
                                                <option key={village.village_name} value={village.village_name}>
                                                    {village.village_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Enhanced Search Input */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            {translations[language].search}
                                        </label>
                                        <div className="relative group">
                                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-2xl blur-sm opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                                            <div className="relative">
                                                <input
                                                    type="text"
                                                    placeholder={translations[language].SearchPlaceholder || "Search landholdings..."}
                                                    value={searchTerm}
                                                    onChange={handleSearch}
                                                    className="w-full pl-12 pr-12 py-2 rounded-2xl bg-white border-2 border-gray-200 text-gray-700 placeholder-gray-500 
                        focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100 focus:shadow-lg
                        hover:border-gray-300 hover:shadow-md
                        transition-all duration-300 font-medium text-sm"
                                                />
                                                <div className="absolute left-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                                    <div className="p-1 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-sm">
                                                        <Search className="h-4 w-4" />
                                                    </div>
                                                </div>
                                                {searchTerm && (
                                                    <button
                                                        onClick={() => setSearchTerm('')}
                                                        className="absolute right-4 top-1/2 transform -translate-y-1/2 p-1.5 rounded-full bg-gray-200 hover:bg-red-100 text-gray-500 hover:text-red-600 transition-all duration-200 hover:scale-110"
                                                        title="Clear search"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                        </svg>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {!isLocationSelectionComplete && (
                                    <p className="text-sm text-amber-600">
                                        {translations[language].selectAllToViewLandholding}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Show content when filter conditions are met */}
            {canShowData && (
                <>
                    {/* Enhanced Loading state */}
                    {loading && (
                        <div className="flex justify-center items-center h-80">
                            <div className="text-center">
                                <div className="inline-flex relative">
                                    <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
                                    <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <MapPin className="h-6 w-6 text-purple-400 animate-pulse" />
                                    </div>
                                </div>
                                <p className="text-gray-400 mt-4">
                                    {filterMode === 'all' ? <span>{translations[language].loadingAllLandholding}</span> : <span>{translations[language].loadingLandholding}</span>}
                                </p>
                            </div>
                        </div>
                    )}

                    {/* Data table */}
                    {!loading && (
                        <div className="overflow-auto rounded-lg shadow border border-gray-200 animate-fadeIn" style={{ animationDelay: '300ms' }}>
                            <div className="overflow-x-auto shadow-md" ref={listRef}>
                                <table className="min-w-full bg-white divide-y divide-gray-200 shadow-sm rounded-lg overflow-hidden">
                                    <thead className="bg-blue-50">
                                        <tr>
                                            {/* <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            {translations[language].LandNo}
                                        </th> */}
                                            {/* {userRole === 18 && ( */}
                                            {/* Data Entry */}
                                            {(userRole === 18 || userRole === 14) && (
                                                <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    {translations[language].Action}
                                                </th>
                                            )}
                                            <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                {translations[language].LandholdersName}
                                            </th>
                                            <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                {translations[language].DistrictName}
                                            </th>
                                            <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                {translations[language].TalukaName}
                                            </th>
                                            <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                {translations[language].VillageName}
                                            </th>
                                            <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                {translations[language].AddSurveyGatNo}
                                            </th>
                                            <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                {translations[language].TotalArea}
                                            </th>
                                            <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                {translations[language].AcquiredArea}
                                            </th>
                                            <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                {translations[language].areaUnit}
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {paginatedData.length > 0 ? (
                                            paginatedData.map((record, index) => {
                                                // Function to truncate landholder name
                                                const truncateName = (name, maxLength = 15) => {
                                                    if (!name) return '';
                                                    if (name.length <= maxLength) return name;
                                                    return name.substring(0, maxLength) + '...';
                                                };

                                                return (
                                                    <React.Fragment key={record.groupNo || index}>
                                                        {/* Main Record Row */}
                                                        <tr className="border-b hover:bg-gray-50 transition-colors duration-200 bg-white">
                                                            {/* <td className="p-3 text-gray-900 font-medium">
                                                            {record.groupNo}
                                                        </td> */}
                                                            {/* {userRole === 18 && ( */}
                                                            {/* Data Entry */}
                                                            {(userRole === 18 || userRole === 14) && (
                                                                <td className="p-3">
                                                                    <div className="flex space-x-2">
                                                                        <button
                                                                            onClick={() => handleEdit(startIndex + index)}
                                                                            className="text-blue-500 hover:text-blue-700 bg-blue-50 p-2 rounded-lg hover:bg-blue-100 transition-colors duration-200"
                                                                            title="Edit Landholding"
                                                                        >
                                                                            <Edit2 size={16} />
                                                                        </button>
                                                                        <button
                                                                            onClick={() => handleDelete(startIndex + index)}
                                                                            className="text-red-500 hover:text-red-700 bg-red-50 p-2 rounded-lg hover:bg-red-100 transition-colors duration-200"
                                                                            title="Delete Landholding"
                                                                        >
                                                                            <Trash2 size={16} />
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            )}
                                                            <td className="p-3">
                                                                <div className="flex items-center space-x-2">
                                                                    {record.owners && record.owners.length > 0 && (
                                                                        <button
                                                                            onClick={() => toggleRow(record.groupNo)}
                                                                            className="text-blue-500 hover:text-blue-700 transition-colors duration-200 flex-shrink-0"
                                                                            title={expandedRow === record.groupNo ? 'Hide Owners' : 'Show Owners'}
                                                                        >
                                                                            <svg
                                                                                className={`w-4 h-4 transform transition-transform duration-200 ${expandedRow === record.groupNo ? 'rotate-180' : ''
                                                                                    }`}
                                                                                fill="currentColor"
                                                                                viewBox="0 0 20 20"
                                                                            >
                                                                                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                                                            </svg>
                                                                        </button>
                                                                    )}
                                                                    <span
                                                                        className="text-gray-900"
                                                                        title={record.landholdersName} // Show full name on hover
                                                                    >
                                                                        {truncateName(record.landholdersName)}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td className="p-3 text-gray-700">{record.DistrictName}</td>
                                                            <td className="p-3 text-gray-700">{record.TalukaName}</td>
                                                            <td className="p-3 text-gray-700">{record.VillageName}</td>
                                                            <td className="p-3 text-gray-700">{record.SurveyNO}</td>
                                                            <td className="p-3 text-gray-700 font-medium">{record.totalArea}</td>
                                                            <td className="p-3 text-gray-700 font-medium">{record.AquiredArea}</td>
                                                            <td className="p-3">
                                                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                                    {record.unit_name}
                                                                </span>
                                                            </td>

                                                        </tr>

                                                        {/* Expanded Owner Rows */}
                                                        {expandedRow === record.groupNo && record.owners && record.owners.length > 0 && (
                                                            <tr className="bg-blue-25">
                                                                <td colSpan={userRole === 18 ? 10 : 9} className="p-0">
                                                                    <div className="bg-blue-25 border-t border-blue-100">
                                                                        <div className="p-4">
                                                                            <h4 className="text-sm font-medium text-gray-700 mb-3 flex items-center">
                                                                                <svg className="w-4 h-4 mr-2 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                                                                                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                                </svg>
                                                                                {translations[language].ownerDetails}({record.owners.length} {record.owners.length === 1 ? 'Owner' : 'Owners'})
                                                                            </h4>
                                                                            <div className="overflow-hidden rounded-lg border border-blue-200">
                                                                                <table className="min-w-full bg-blue-25 divide-y divide-blue-200">
                                                                                    <thead className="bg-blue-100">
                                                                                        <tr>
                                                                                            <th className="p-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                                                                                                {translations[language].LandNo}
                                                                                            </th>
                                                                                            <th className="p-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                                                                                                {translations[language].ownerName}
                                                                                            </th>
                                                                                            <th className="p-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                                                                                                {translations[language].DistrictName}
                                                                                            </th>
                                                                                            <th className="p-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                                                                                                {translations[language].TalukaName}
                                                                                            </th>
                                                                                            <th className="p-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                                                                                                {translations[language].VillageName}
                                                                                            </th>
                                                                                            <th className="p-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                                                                                                {translations[language].SurveyNo}
                                                                                            </th>
                                                                                            <th className="p-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                                                                                                {translations[language].TotalArea}
                                                                                            </th>
                                                                                            <th className="p-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                                                                                                {translations[language].AcquiredArea}
                                                                                            </th>
                                                                                            <th className="p-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                                                                                                {translations[language].areaUnit}
                                                                                            </th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody className="bg-blue-25 divide-y divide-blue-100">
                                                                                        {record.owners.map((owner, ownerIndex) => (
                                                                                            <tr
                                                                                                key={owner.land_owner_id}
                                                                                                className={`hover:bg-blue-50 transition-colors duration-150 ${ownerIndex % 2 === 0 ? 'bg-blue-25' : 'bg-white/50'
                                                                                                    }`}
                                                                                            >
                                                                                                <td className="p-3 text-gray-700 font-medium">
                                                                                                    {owner.LandAcquisition_id}
                                                                                                </td>
                                                                                                <td className="p-3 text-gray-800 font-medium" title={owner.owner_name}>
                                                                                                    {truncateName(owner.owner_name, 20)}
                                                                                                </td>
                                                                                                <td className="p-3 text-gray-700">
                                                                                                    {owner.dist_name}
                                                                                                </td>
                                                                                                <td className="p-3 text-gray-700">
                                                                                                    {owner.taluka_name}
                                                                                                </td>
                                                                                                <td className="p-3 text-gray-700">
                                                                                                    {owner.village_name}
                                                                                                </td>
                                                                                                <td className="p-3 text-gray-700">
                                                                                                    {owner.survey_no}
                                                                                                </td>
                                                                                                <td className="p-3 text-gray-700 font-medium">
                                                                                                    {owner.owner_total_area}
                                                                                                </td>
                                                                                                <td className="p-3 text-gray-700 font-medium">
                                                                                                    {owner.owner_aqr_area}
                                                                                                </td>
                                                                                                <td className="p-3">
                                                                                                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                                                                        {record.unit_name}
                                                                                                    </span>
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={userRole === 18 ? 10 : 9} className="p-8 text-center text-gray-500">
                                                    <div className="flex flex-col items-center space-y-2">
                                                        <svg className="w-12 h-12 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                        </svg>
                                                        <p className="text-lg font-medium">
                                                            {loading ? 'Loading data...' : 'No records found'}
                                                        </p>
                                                        {!loading && (
                                                            <p className="text-sm text-gray-400">
                                                                {translations[language].tryAdjustingSearch}
                                                            </p>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* Pagination Controls - Compact Design */}
                    {!loading && filteredData.length > itemsPerPage && (
                        <div className="flex items-center justify-between mt-4 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md">
                            <div className="flex items-center text-xs text-gray-600">
                                <span>
                                    {translations[language].showing} {startIndex + 1} {translations[language].to} {Math.min(endIndex, filteredData.length)} {translations[language].of} {filteredData.length} {translations[language].results}
                                </span>
                            </div>

                            <div className="flex items-center space-x-1">
                                {/* Previous Button */}
                                <button
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                    className="px-2 py-1 text-xs font-medium text-gray-500 bg-white border border-gray-300 rounded hover:bg-gray-50 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                                >
                                    {translations[language].prev}
                                </button>

                                {/* Page Numbers */}
                                <div className="flex items-center space-x-1">
                                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
                                        <button
                                            key={pageNum}
                                            onClick={() => setCurrentPage(pageNum)}
                                            className={`px-2 py-1 text-xs font-medium rounded transition-colors duration-200 ${currentPage === pageNum
                                                ? 'bg-blue-600 text-white'
                                                : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 hover:text-gray-900'
                                                }`}
                                        >
                                            {pageNum}
                                        </button>
                                    ))}
                                </div>

                                {/* Next Button */}
                                <button
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                    className="px-2 py-1 text-xs font-medium text-gray-500 bg-white border border-gray-300 rounded hover:bg-gray-50 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                                >
                                    {translations[language].next}
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* Message when neither condition is met */}
            {!canShowData && !loading && filterMode === 'location' && (
                <div className="text-center py-12">
                    <MapPin className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                    <p className="text-gray-500 text-lg">{translations[language].selectAllToViewData}</p>
                </div>
            )}

            {/* Add Landholding Form Section - No Container */}
            <div ref={formRef}>
                {showAddForm && (
                    <RailwayAddLandHoldingList
                        onBack={handleAddCancel}
                        onSuccess={handleAddSuccess}
                        projectId={currentProjectId}
                        proposalId={proposalId}
                    />
                )}
            </div>
            {/* Edit Landholding Form Section - No Container */}
            {showEditForm && editingLandholding && (
                <RailwayEditLandHoldingList
                    onBack={handleEditCancel}
                    onSuccess={handleEditSuccess}
                    LandAcquisition_id={editingLandholding.groupNo}
                />
            )}

            {/* Download Modal */}
            <DownloadModal
                isOpen={downloadModalOpen}
                onClose={() => setDownloadModalOpen(false)}
                title={translations[language].LandholdingManagement}
                data={getDataForDownload()}
                columns={getColumnsForDownload()}
                isLoading={downloadLoading}
                setIsLoading={setDownloadLoading}
                screenName="Landholding Management"
            />

            {showAlertModal && (
                <div className="fixed top-4 right-4 z-50">
                    <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
                        alertConfig.type === 'warning' ? 'border-yellow-500' :
                            alertConfig.type === 'info' ? 'border-blue-500' :
                                'border-green-500'
                        }`}>
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                                    alertConfig.type === 'warning' ? 'bg-yellow-100' :
                                        alertConfig.type === 'info' ? 'bg-blue-100' :
                                            'bg-green-100'
                                    }`}>
                                    <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                                        alertConfig.type === 'warning' ? 'text-yellow-600' :
                                            alertConfig.type === 'info' ? 'text-blue-600' :
                                                'text-green-600'
                                        }`}>
                                        {alertConfig.type === 'error' ? '✕' :
                                            alertConfig.type === 'warning' ? '⚠' :
                                                alertConfig.type === 'info' ? 'ℹ' : '✓'}
                                    </span>
                                </div>
                            </div>
                            <div className="ml-3 flex-1">
                                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
                            </div>
                            <button
                                onClick={() => setShowAlertModal(false)}
                                className="ml-4 text-gray-400 hover:text-gray-600"
                            >
                                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 222222222222222222222 */}
            {/* Send to Collector/LAO/Samanvay Modal */}
            {showSendToCollectorModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            {/* Show restoration message only when restored */}
                            {shouldRestoreModal && modalParams && (
                                <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                                    <p className="text-sm text-blue-700">
                                        Previous selections restored.
                                        {modalParams.selectedDocumentName &&
                                            ` Re-select document: ${modalParams.selectedDocumentName}`
                                        }
                                    </p>
                                </div>
                            )}
                            {/* Modal Content */}
                            <div className="space-y-4">

                                {/* User Selection based on role */}
                                <div className="space-y-6">

                                    {/* Collector Role - Show LAO selection */}
                                    {sendToRole === 'Collector' && (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {translations[language]?.ProposeLAOOfficer} *
                                            </label>
                                            <select
                                                value={selectedLao}
                                                onChange={(e) => {
                                                    setSelectedLao(e.target.value);
                                                    setChangeLao(true);
                                                }}
                                                disabled={loadingUsers}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            >
                                                <option value="">
                                                    {loadingUsers ? <span>{translations[language]?.LoadingLAOUsers}</span> : <span>{translations[language]?.SelectLAOOfficer}</span>}
                                                </option>

                                                {/* Pre-assigned LAOs */}
                                                {assignLAO && Array.isArray(assignLAO) && assignLAO.map((user) => (
                                                    <option key={`assigned-${user.usr_id || user.id}`} value={user.usr_id || user.id}>
                                                        {user.full_name || user.user_name} ({user.usr_role}) - {translations[language]?.Assigned}
                                                    </option>
                                                ))}

                                                {/* All other LAOs */}
                                                {laoUsers && Array.isArray(laoUsers) && laoUsers
                                                    .filter(lao => !assignLAO || !Array.isArray(assignLAO) || !assignLAO.some(assigned =>
                                                        (assigned.usr_id || assigned.id) === (lao.usr_id || lao.id)
                                                    ))
                                                    .map((user) => (
                                                        <option key={`all-${user.usr_id || user.id}`} value={user.usr_id || user.id}>
                                                            {user.full_name || user.user_name} ({user.usr_role})
                                                        </option>
                                                    ))}
                                            </select>

                                            {/* Hidden Collector Selection */}
                                            <div className="hidden">
                                                <select
                                                    value={selectedUser}
                                                    onChange={(e) => setSelectedUser(e.target.value)}
                                                    disabled={loadingUsers}
                                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                >
                                                    <option value="">{loadingUsers ? <span>{translations[language]?.LoadingUsers}</span> : <span>{translations[language]?.SelectCollector}</span>}</option>
                                                    {users.map((user) => (
                                                        <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                            {user.full_name || user.user_name} ({user.usr_role})
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    {/* LAO Role */}
                                    {sendToRole === 'LAO' && (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {translations[language]?.SelectLAOOfficer} *
                                            </label>
                                            <select
                                                value={selectedLao}
                                                onChange={(e) => {
                                                    setSelectedLao(e.target.value);
                                                    setChangeLao(true);
                                                }}
                                                disabled={loadingUsers}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            >
                                                <option value="">
                                                    {loadingUsers ? <span>{translations[language]?.LoadingLAOUsers}</span> : <span>{translations[language]?.SelectLAOOfficer}</span>}
                                                </option>

                                                {/* Pre-assigned LAOs */}
                                                {assignLAO && Array.isArray(assignLAO) && assignLAO.map((user) => (
                                                    <option key={`assigned-${user.usr_id || user.id}`} value={user.usr_id || user.id}>
                                                        {user.full_name || user.user_name} ({user.usr_role}) - Assigned
                                                    </option>
                                                ))}

                                                {/* All other LAOs */}
                                                {laoUsers && Array.isArray(laoUsers) && laoUsers
                                                    .filter(lao => !assignLAO || !Array.isArray(assignLAO) || !assignLAO.some(assigned =>
                                                        (assigned.usr_id || assigned.id) === (lao.usr_id || lao.id)
                                                    ))
                                                    .map((user) => (
                                                        <option key={`all-${user.usr_id || user.id}`} value={user.usr_id || user.id}>
                                                            {user.full_name || user.user_name} ({user.usr_role})
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    )}

                                    {/* Samanvay Role */}
                                    {sendToRole === 'Samanvay' && (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {translations[language]?.SelectSamanvayOfficer} *
                                            </label>
                                            <select
                                                value={selectedUser}
                                                onChange={(e) => setSelectedUser(e.target.value)}
                                                disabled={loadingUsers}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            >
                                                <option value="">
                                                    {loadingUsers ? <span>{translations[language]?.LoadingUsers}</span> : <span>{translations[language]?.SelectSamanvayOfficer}</span>}
                                                </option>
                                                {users && Array.isArray(users) && users.map((user) => (
                                                    <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                        {user.full_name || user.user_name} ({user.usr_role})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.Remarks}
                                    </label>
                                    <textarea
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder={translations[language]?.EnterRemarks}
                                    />
                                </div>

                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.UploadDocument} *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setSelectedDocument(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                    {selectedDocument && (
                                        <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                            <div className="flex items-center justify-between mb-2">
                                                <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                                    {translations[language]?.Selected}: {selectedDocument.name}
                                                </p>
                                                <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                                    {(selectedDocument.size / 1024 / 1024).toFixed(2)} MB
                                                </span>
                                            </div>
                                            <div className="flex gap-2">
                                                {selectedDocument.type === 'application/pdf' && (
                                                    <>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if (selectedDocument?.type === 'application/pdf') {
                                                                    setPdfForSigning(selectedDocument);
                                                                    setShowSignaturePad(true);
                                                                }
                                                            }}
                                                            disabled={uploadStatus === 'uploading'}
                                                            className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                                        >
                                                            {uploadStatus === 'uploading' ? (
                                                                <>
                                                                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                                                    Signing...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                    </svg>
                                                                    Sign Doc
                                                                </>
                                                            )}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleViewDocument(
                                                                uploadStatus === 'success' ? selectedSignDocument : selectedDocument
                                                            )}
                                                            className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                                                        >
                                                            <Eye className="h-3 w-3" />
                                                            {translations[language]?.View}
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                            {/* Upload status messages */}
                                            {uploadStatus === 'success' && (
                                                <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                                                    ✅ Document Signed Successfully
                                                </div>
                                            )}
                                            {uploadStatus === 'error' && uploadError && (
                                                <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                                                    ❌ {uploadError}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {(sendToRole === 'Collector' || sendToRole === 'LAO') && (
                                    <div className="flex justify-start">
                                        <button
                                            onClick={handleCoveringLetterClick}
                                            className="px-4 py-2 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                                        >
                                            भूसंपादन अधिकारी नियुक्ती
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* Modal Actions */}
                            <div className="flex flex-col gap-4 mt-6 pt-4 border-t">

                                {/* Buttons Row */}
                                <div className="flex justify-end gap-3">
                                    <button
                                        onClick={() => setShowSendToCollectorModal(false)}
                                        className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                        disabled={sendingToCollecotr || sendingToSamanvay || sendingToLAO || showProgress}
                                    >
                                        {translations[language]?.Cancel}
                                    </button>

                                    <button
                                        onClick={handleSendToSurveyor}
                                        disabled={
                                            showProgress ||
                                            (sendToRole === 'Samanvay' && (!selectedUser || !selectedDocument || sendingToSamanvay)) ||
                                            (sendToRole === 'Collector' && (!selectedUser || !selectedLao || !selectedDocument || sendingToCollector)) ||
                                            (sendToRole === 'LAO' && (!selectedLao || !selectedDocument || sendingToLAO))
                                        }
                                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                    >
                                        {(sendingToSamanvay && sendToRole === 'Samanvay') ||
                                            (sendingToCollector && sendToRole === 'Collector') ||
                                            (sendingToLAO && sendToRole === 'LAO') || showProgress ? (
                                            <>
                                                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                                {showProgress ? translations[language].saving : translations[language].CommonSave}
                                            </>
                                        ) : (
                                            <>
                                                <Send className="mr-2 h-4 w-4" />
                                                {translations[language].CommonSave}
                                            </>
                                        )}
                                    </button>
                                </div>

                                {/* Progress Bar - Full width under buttons */}
                                {showProgress && (
                                    <div className="w-full">
                                        <ProgressBar progress={uploadProgress} isVisible={showProgress} />
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                    {/* SignaturePad Modal */}
                    {showSignaturePad && pdfForSigning && (
                        <SignaturePad
                            pdfFile={pdfForSigning}
                            onSign={(signaturesArray) => {
                                setShowSignaturePad(false);
                                signDocument(pdfForSigning, signaturesArray).then(() => {
                                    setPdfForSigning(null);
                                });
                            }}
                            onCancel={() => {
                                setShowSignaturePad(false);
                                setPdfForSigning(null);
                            }}
                        />
                    )}
                </div>
            )}

            {/* Edit Landholding Modal */}
            {showEditLandholdingModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
                        <RailwayEditLandHoldingList
                            LandAcquisition_id={editingLandholdingId}
                            onBack={async () => {
                                setShowEditLandholdingModal(false);
                                setEditingLandholdingId(null);
                                await refreshRecords();
                                setSuccessMessage('Landholding updated successfully!');
                                setShowSuccess(true);
                                setTimeout(() => setShowSuccess(false), 3000);
                            }}
                        />
                    </div>
                </div>
            )}

            {/* Document Viewer Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-2">
                            <h3 className="text-xl font-semibold text-gray-800">{translations[language]?.DocumentPreview}</h3>
                            <button
                                onClick={() => {
                                    setShowModal(false);
                                    URL.revokeObjectURL(documentUrl);
                                }}
                                className="text-gray-400 hover:text-gray-700 text-2xl font-bold"
                            >
                                ×
                            </button>
                        </div>

                        {/* Document Viewer */}
                        <iframe
                            src={documentUrl}
                            className="w-full h-[80vh] rounded border border-gray-300"
                            title="Document Preview"
                        />
                    </div>
                </div>
            )}
            {/* Simple Confirmation Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
                        <div className="p-6">
                            <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                                    'bg-blue-100'
                                }`}>
                                {confirmConfig.type === 'danger' ? '⚠' :
                                    confirmConfig.type === 'warning' ? '⚠' : '?'}
                            </div>

                            <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                                {confirmConfig.title}
                            </h3>

                            <p className="text-gray-600 text-sm mb-6 text-center">
                                {confirmConfig.message}
                            </p>

                            <div className="flex gap-3">
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onCancel) confirmConfig.onCancel();
                                    }}
                                    className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                                >
                                    {translations[language].cancel}
                                </button>
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                                    }}
                                    className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                                        confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                                            'bg-blue-600 hover:bg-blue-700'
                                        }`}
                                >
                                    {translations[language].confirm}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Simple Alert Notification */}
            {showAlertModal && (
                <div className="fixed top-4 right-4 z-50">
                    <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
                        alertConfig.type === 'warning' ? 'border-yellow-500' :
                            alertConfig.type === 'info' ? 'border-blue-500' :
                                'border-green-500'
                        }`}>
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                                    alertConfig.type === 'warning' ? 'bg-yellow-100' :
                                        alertConfig.type === 'info' ? 'bg-blue-100' :
                                            'bg-green-100'
                                    }`}>
                                    <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                                        alertConfig.type === 'warning' ? 'text-yellow-600' :
                                            alertConfig.type === 'info' ? 'text-blue-600' :
                                                'text-green-600'
                                        }`}>
                                        {alertConfig.type === 'error' ? '✕' :
                                            alertConfig.type === 'warning' ? '⚠' :
                                                alertConfig.type === 'info' ? 'ℹ' : '✓'}
                                    </span>
                                </div>
                            </div>
                            <div className="ml-3 flex-1">
                                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
                            </div>
                            <button
                                onClick={() => setShowAlertModal(false)}
                                className="ml-4 text-gray-400 hover:text-gray-600"
                            >
                                <X className="h-4 w-4" />
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Loading Message */}
            {loadingRecords && (
                <div className="flex justify-center items-center h-80">
                    <div className="text-center">
                        <div className="inline-flex relative">
                            <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
                            <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <MapPin className="h-6 w-6 text-purple-400 animate-pulse" />
                            </div>
                        </div>
                        <p className="text-gray-400 mt-4">{translations[language]?.LoadingLandRecords}</p>
                    </div>
                </div>
            )}


        </div>
    );
};


export default RailwayLandHoldingList;